/**
 * DeviceGateCard - Expandable card with checkbox toggle.
 *
 * When checked, expands to show children (device config form).
 * Uses Mantine Collapse for animation.
 */

import { Card, Checkbox, Collapse, Group, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

export interface DeviceGateCardProps {
  title: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}

export function DeviceGateCard({
  title,
  description,
  checked,
  onChange,
  children,
}: DeviceGateCardProps) {
  return (
    <Card withBorder radius="md" p="md">
      <Stack gap="sm">
        <Group>
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.currentTarget.checked)}
          />
          <div>
            <Text fw={500}>{title}</Text>
            <Text size="xs" c="dimmed">{description}</Text>
          </div>
        </Group>
        <Collapse in={checked}>
          <div style={{ paddingTop: 8 }}>
            {children}
          </div>
        </Collapse>
      </Stack>
    </Card>
  );
}
